import _extends from "@babel/runtime/helpers/extends";
import React, { memo } from 'react';
import { components } from 'react-select';
const Input = _ref => {
  let {
    ...props
  } = _ref;
  const {
    inputProps = {}
  } = props.selectProps;
  return /*#__PURE__*/React.createElement(components.Input, _extends({}, props, inputProps));
};
export default /*#__PURE__*/memo(Input);